export default () => {
  return {
    default: {
      '> li': {
        margin: 0,
      },
    },
  } as const
}
